import { CreatePartnerRequest } from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useCreatePartner() {
  const [creating, setCreating] = useState(false);

  async function createPartner(params: CreatePartnerRequest) {
    try {
      setCreating(true);
      const res = await api.createPartner(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setCreating(false);
    }
  }

  return { creating, createPartner };
}
